import { RouteObject } from 'react-router-dom';
import { Suspense, lazy } from 'react';
import { LoadingSpinner } from '@/components/ui/loading-spinner';
import { ProtectedRoute } from '@/components/ProtectedRoute';

const RoleBasedProfile = lazy(() => import('@/components/RoleBasedProfile'));

export const profileRoutes: RouteObject[] = [
  {
    path: 'profile',
    element: (
      <Suspense fallback={<LoadingSpinner size="md" />}>
        <ProtectedRoute>
          <RoleBasedProfile />
        </ProtectedRoute>
      </Suspense>
    ),
  },
];
